export const BANK_APPROVAL_ERROR = 'BankApprovalError';
export const WALLET_ACCESS_ERROR = 'WalletAccessError';

export const OAUTH_MISSING_EMAIL_ERROR_CODE = '23000';
export const OAUTH_LOCKED_ACCOUNT_ERROR_CODE = '23001';
